<script lang="ts" setup>
import { twMerge } from "tailwind-merge";
import type { HTMLAttributes } from "vue";
import { RouterLink } from "vue-router";

const props = withDefaults(
	defineProps<{
		href: string;
		class?: HTMLAttributes["class"];
	}>(),
	{},
);
</script>

<template>
	<RouterLink
		:class="twMerge('transition-colors hover:text-foreground', props.class)"
		:to="props.href"
	>
		<slot />
	</RouterLink>
</template>
